import { IDecisionTree, DecisionTreeContent } from "@amzn/ask-legal-domain";
import { API as RestAPI } from "aws-amplify";
import { AppContextValue } from "../setup/context-value";
import { APIResponse, toDefaultRequestPayload } from "./common";

export interface DecisionTreeNodeAPI {
    update(input: IDecisionTree.UpdateDraftInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>>;
    get(input: IDecisionTree.GetNodeInput): Promise<APIResponse<IDecisionTree.GetNodeOutput>>;
    batchUpdate(input: IDecisionTree.BatchUpdateInput): Promise<APIResponse<IDecisionTree.BatchUpdateOutput>>;
    createOrphanNode(input: IDecisionTree.CreateOrphanNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>>;
    deleteNode(input: IDecisionTree.DeleteNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>>;
    batchDelete(input: IDecisionTree.BatchDeleteInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>>;
    copyNode(input: IDecisionTree.CopyNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>>;
}

export class DecisionTreeNodeAPIImpl implements DecisionTreeNodeAPI {
    constructor (private context: AppContextValue) {}


    async update(input: IDecisionTree.UpdateDraftInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>> {
        const response: APIResponse<IDecisionTree.UpdateDraftOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/update",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async get (id: IDecisionTree.GetNodeInput): Promise<APIResponse<IDecisionTree.GetNodeOutput>> {
        const response: APIResponse<IDecisionTree.GetNodeOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/get",
            toDefaultRequestPayload(id)
        );
        return response;
    }

    async batchUpdate(input: IDecisionTree.BatchUpdateInput): Promise<APIResponse<IDecisionTree.BatchUpdateOutput>> {
        const response: APIResponse<IDecisionTree.BatchUpdateOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/batch-update",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async createOrphanNode(input: IDecisionTree.CreateOrphanNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>> {
        const response: APIResponse<IDecisionTree.UpdateDraftOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/create-orphan-node",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async deleteNode(input: IDecisionTree.DeleteNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>> {
        const response: APIResponse<IDecisionTree.UpdateDraftOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/delete-node",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async batchDelete(input: IDecisionTree.BatchDeleteInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>> {
        const response: APIResponse<IDecisionTree.UpdateDraftOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/batch-delete",
            toDefaultRequestPayload(input)
        );
        return response;
    }

    async copyNode(input: IDecisionTree.CopyNodeInput): Promise<APIResponse<IDecisionTree.UpdateDraftOutput>> {
        const response: APIResponse<IDecisionTree.UpdateDraftOutput> = await RestAPI.post(
            "custom-domain",
            "/decision-tree-node/copy-node",
            toDefaultRequestPayload(input)
        );
        return response;
    }
}
